<template>
    <section>
        <Sidebar />
        <Content>
            <h1>API Tests</h1>
            <div class="row">
                <template v-if="loading">
                    <img src="/img/loading-devect.gif" style="width: 100px; height: 100px; position: absolute; top: 50%; left: 50%; margin-left: 90px; margin-top: -50px;">
                </template>
                <template v-if="endpoints.length > 0">
                    <APITestBox 
                        v-for="endpoint in endpoints"
                        :key="endpoint.id"
                        :apiTest="endpoint" />
                </template>
                <template v-if="loading == false">
                    <APITestBox />
                </template>
            </div>
        </Content>
    </section>
</template>

<script>
import Sidebar from "../components/sidebar/Sidebar"
import Content from "../components/Content"
import APITestBox from "../components/APITestBox"
import {getEndpoints, intervalToText} from "../logic/endpoints"

let endpoints = []

export default {
    name: 'Home',
    components: {Sidebar, Content, APITestBox},
    data() {
      return {
        msg: "Hello World",
        endpoints: endpoints,
        loading: true
      }
    },
    methods: {
        _getEndpoints: function(){
            getEndpoints().then(response => {
                this.endpoints = response.data.results
                this.loading = false;
            })
        },
    },
    mounted: function(){
      this._getEndpoints()
    }
}
</script>

<style scoped>
  h1{margin-bottom: 24px;}
</style>